import React, { useEffect } from 'react';
import { bool, node, string, shape } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { routes } from '@constants';
import { SUCCESS } from '@constants/requestPhase';
import { getCurrentUser, resetPhases as resetUserPhases, resetStore as resetUserStore } from '@store/user/duck';
import { resetStore as resetCompanyStore } from '@store/company/duck';
import { resetStore as resetLocationStore } from '@store/location/duck';
import { storage } from '@utils';
import { clearStorage } from '@helpers/common';
import { useMixpanel } from '@hooks';

const AuthorizedRoute = ({ exact, path, children, location }) => {
  const token = storage.getToken();

  const { currentLocation } = useSelector(store => store.locationStore);
  const { user, getCurrentUserPhase, getCurrentUserError } = useSelector(store => store.userStore);

  const dispatch = useDispatch();
  const { mixpanel } = useMixpanel();

  useEffect(() => {
    if (Object.keys(user).length === 1) {
      dispatch(getCurrentUser());
    }
  }, []);

  useEffect(() => {
    if (currentLocation?.title) {
      mixpanel.people.set({
        'User Location': currentLocation.title,
      });
    }
  }, [currentLocation, mixpanel]);

  useEffect(() => {
    if (getCurrentUserPhase === SUCCESS) {
      dispatch(resetUserPhases());

      mixpanel.identify(`${user?.id}`);

      mixpanel.people.set_once({
        $email: user.email,
        $name: `${user.firstName} ${user.lastName}`,
      });
    }
  }, [getCurrentUserPhase, mixpanel]);

  useEffect(() => {
    if (getCurrentUserError && getCurrentUserError.status === 403) {
      clearStorage();
      Auth.signOut();
      dispatch(resetUserStore());
      dispatch(resetLocationStore());
      dispatch(resetCompanyStore());
    }
  }, [getCurrentUserError]);

  if (!token) {
    return <Redirect to={`${routes.login}?redirect=${window.location.pathname}`} />;
  }

  return (
    <Route exact={exact} path={path} location={location}>
      {children}
    </Route>
  );
};

AuthorizedRoute.defaultProps = {
  exact: false,
  location: undefined,
};

AuthorizedRoute.propTypes = {
  exact: bool,
  path: string.isRequired,
  children: node.isRequired,
  location: shape({}),
};

export default AuthorizedRoute;
